import { render, staticRenderFns } from "./ExampleComponentTable.vue?vue&type=template&id=600954a2&scoped=true"
import script from "./ExampleComponentTable.vue?vue&type=script&lang=js"
export * from "./ExampleComponentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600954a2",
  null
  
)

export default component.exports